// Role-based defaults: roles that always get view+add+edit for a section
const ROLE_DEFAULTS = {
  'Risk Registers':      ['risk_owner', 'risk_champion', 'risk_admin', 'manager', 'director', 'Risk Owner', 'Risk Champion', 'Risk Administrator', 'Manager', 'Director'],
  'Risk Assessment':     ['risk_owner', 'risk_champion', 'risk_admin', 'manager', 'director', 'Risk Owner', 'Risk Champion', 'Risk Administrator', 'Manager', 'Director'],
  'Controls & Treatment':['risk_owner', 'risk_champion', 'risk_admin', 'manager', 'director', 'Risk Owner', 'Risk Champion', 'Risk Administrator', 'Manager', 'Director'],
  'SHE Compliance':      ['she_officer', 'she_manager', 'risk_owner', 'risk_champion', 'risk_admin', 'manager', 'director', 'SHE Officer', 'SHE Manager', 'Risk Owner', 'Risk Champion', 'Risk Administrator', 'Manager', 'Director'],
  'Loss Events':         ['she_officer', 'she_manager', 'risk_owner', 'risk_champion', 'risk_admin', 'manager', 'director', 'SHE Officer', 'SHE Manager', 'Risk Owner', 'Risk Champion', 'Risk Administrator', 'Manager', 'Director'],
  'Insurance Claims':    ['she_officer', 'she_manager', 'risk_owner', 'risk_champion', 'risk_admin', 'manager', 'director', 'SHE Officer', 'SHE Manager', 'Risk Owner', 'Risk Champion', 'Risk Administrator', 'Manager', 'Director'],
  'Business Continuity': ['risk_owner', 'risk_champion', 'risk_admin', 'manager', 'director', 'Risk Owner', 'Risk Champion', 'Risk Administrator', 'Manager', 'Director'],
  'Analysis & Reports':  ['she_officer', 'she_manager', 'risk_owner', 'risk_champion', 'risk_admin', 'manager', 'director', 'SHE Officer', 'SHE Manager', 'Risk Owner', 'Risk Champion', 'Risk Administrator', 'Manager', 'Director'],
  'Monte Carlo Analysis':['she_officer', 'she_manager', 'risk_owner', 'risk_champion', 'risk_admin', 'manager', 'director', 'SHE Officer', 'SHE Manager', 'Risk Owner', 'Risk Champion', 'Risk Administrator', 'Manager', 'Director'],
};

const DEFAULT_ACTIONS = ['view', 'add', 'edit', 'update'];

export const hasPermission = (user, section, action) => {
  if (!user || !user.roles) return false;
  
  // System Admins have full access to everything
  if (user.roles.includes('sys_admin') || user.roles.includes('System Administrator')) return true;

  // Role-based default: if the user's role is in the defaults for this section,
  // grant view/add/edit automatically (delete still requires explicit DB permission)
  const normalizedAction = action.toLowerCase();
  if (DEFAULT_ACTIONS.includes(normalizedAction)) {
    const allowedRoles = ROLE_DEFAULTS[section] || [];
    const hasRoleDefault = user.roles.some(r => allowedRoles.some(a => a.toLowerCase() === r.toLowerCase()));
    if (hasRoleDefault) return true;
  }

  if (!user.permissions) return false;

  // Find the permission for the specific section
  const sectionPerm = user.permissions.find(p => 
    p.section_name.toLowerCase() === section.toLowerCase() ||
    p.section_name.toLowerCase().includes(section.toLowerCase())
  );

  if (!sectionPerm) return false;

  // Map action to specific permission field
  const actionMap = {
    view: 'can_view',
    add: 'can_add',
    edit: 'can_edit',
    delete: 'can_delete',
    update: 'can_edit',
    approve: 'can_approve'
  };

  const field = actionMap[normalizedAction];
  return field ? parseInt(sectionPerm[field]) === 1 : false;
};
